import React from 'react';

function Static() {

    // Renders the initial Static image on the TV
    return (
        <div className='static'></div>
    )
}
export default Static;